import { COVERS_WITHOUT_NAMES } from '../utils/data';
import ImageFromStorage from './ImageFromStorage';

const CustomCover = ({
  cover,
  coverPhoto,
  width = 320,
  withPhoto,
  name,
  title,
}) => {
  const baseWidth = 320;
  const scale = width / baseWidth;

  return (
    <div style={{ position: 'relative', width }}>
      <img
        style={{ width }}
        src={COVERS_WITHOUT_NAMES[cover - 1]}
        alt="memowrite book cover"
      />
      {withPhoto ? (
        <div
          style={{
            backgroundColor: 'silver',
            width: 122 * scale,
            height: 150 * scale,
            position: 'absolute',
            top: 98 * scale,
            left: 106 * scale,
          }}
        >
          {coverPhoto ? (
            <ImageFromStorage
              link={coverPhoto}
              height={150 * scale}
              width={122 * scale}
              objectFit="cover"
            />
          ) : (
            <div style={{ height: 150 * scale, width: 122 * scale }}></div>
          )}
          {name && (
            <div
              style={{
                marginLeft: -20 * scale,
                marginRight: -20 * scale,
                marginTop: 10 * scale,
                height: 34 * scale,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <h6
                style={{
                  color: String(cover).match(/2|5/g) ? 'black' : 'white',
                  fontSize: 14 * scale,
                  marginBottom: 0,
                  textAlign: 'center',
                }}
              >
                {name}
              </h6>
            </div>
          )}
          {title && (
            <p
              style={{
                color: String(cover).match(/2|5/g) ? 'black' : 'white',
                fontSize: 8 * scale,
                marginTop: 2 * scale,
                marginBottom: 0,
                letterSpacing: 2 * scale,
                textAlign: 'center',
              }}
            >
              {title.toUpperCase()}
            </p>
          )}
        </div>
      ) : (
        <>
          <div
            style={{
              position: 'absolute',
              top: 145 * scale,
              left: 82 * scale,
              width: 170 * scale,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            {title && (
              <p
                style={{
                  color: String(cover).match(/8|11/g) ? 'black' : 'white',
                  fontSize: 8 * scale,
                  marginBottom: 0,
                  letterSpacing: 2 * scale,
                }}
              >
                {title.toUpperCase()}
              </p>
            )}
          </div>
          <div
            style={{
              position: 'absolute',
              top: 163 * scale,
              left: 82 * scale,
              height: 70 * scale,
              width: 170 * scale,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            {name && (
              <h6
                style={{
                  color: String(cover).match(/8|11/g) ? 'black' : 'white',
                  fontSize: 22 * scale,
                  marginBottom: 0,
                }}
              >
                {name}
              </h6>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CustomCover;
